import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './login.scss';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';

export default function LoginComponent() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const { login, currentUser } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (currentUser) navigate('/search');
    }, [currentUser, navigate]);

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        try {
            setError('');
            setLoading(true);
            await login(email, password);
            navigate('/search');
        } catch (err) {
            setError('Invalid email or password');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="login-container">
            <div className="login-form-container">
                <img src="/favicon.png" alt="Site Reviver Logo" className="logo" />

                <div className="welcome-text">
                    <h1>Welcome back</h1>
                    <p>Please enter your details</p>
                </div>

                {error && (
                    <div className="error-message">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                        <label htmlFor="email">Email address</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="you@example.com"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <div className="password-input-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="••••••••"
                            />
                            {password && (
                                <span
                                    className="show-password-text"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? "hide password" : "show password"}
                                </span>
                            )}
                        </div>
                    </div>

                    <div className="remember-forgot">
                        <label>
                            <input
                                type="checkbox"
                                checked={rememberMe}
                                onChange={(e) => setRememberMe(e.target.checked)}
                            />
                            Remember for 30 days
                        </label>
                        <a href="/forgot-password">Forgot password?</a>
                    </div>

                    <button
                        type="submit"
                        className="submit-button"
                        disabled={loading}
                    >
                        {loading ? 'Signing in...' : 'Sign in'}
                    </button>
                </form>
            </div>

            <div className="image-container" style={{
                backgroundImage: 'url(/login-image.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}>
                <div className="overlay">
                    <h2>Bring your ideas to life.</h2>
                    <p>Sign up for free and enjoy access to all features for 30 days.</p>
                </div>
            </div>
        </div>
    );
} 